// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_aa0597be","description":"_ab39f96b","imageWrapper":"_df678979","image":"_52323a4a","title":"_ba94280d","creator":"_13306d31"};